import React, {PureComponent} from "react"
import {get, merge} from "lodash"

import client, {Query, pagination} from "@irati/utils/services/apollo"
import {QueryComponentProps} from "@irati/utils/services/apollo/Query"
import {ApolloState} from "@irati/utils/services/apollo/apolloStateInterface"
import {DealList, QueryDealsArgs, Deal} from "@irati/types"
import {List} from "@irati/utils/services/apollo/helpers/pagination"

import DealListQuery, {dealListQueryKey} from "../../services/queries/dealList"

export const query = DealListQuery
export const queryKey = dealListQueryKey

export function updateDealList(variables: DealListVariables, deal: Deal) {
  try {
    const data = client.readQuery({query, variables})
    const deals: DealList = data[dealListQueryKey]
    if (deals && deals.results) {
      const cachedDeal = deals.results.filter((t) => t.uuid === deal.uuid)[0]
      let cachedDeals = [...deals.results]
      if (cachedDeal) {
        const index = deals.results.indexOf(cachedDeal)
        cachedDeals[index] = merge(cachedDeal, deal)
      } else {
        cachedDeals = [deal, ...cachedDeals]
      }
      client.writeQuery({query, variables, data: {[queryKey]: {...deals, results: cachedDeals}}})
    }
  } catch (e) {
    console.error("[DealList]: Failed to update cache")
  }
}

export function removeFromDealList(variables: DealListVariables, deal: Deal) {
  try {
    const data = client.readQuery({query, variables})
    const deals: DealList = data[dealListQueryKey]
    const updatedList = deals.results.filter((t) => t.uuid !== deal.uuid)
    client.writeQuery({query, variables, data: {[queryKey]: {...deals, results: updatedList}}})
  } catch (e) {
    console.error("[DealList]: Failed to update cache")
  }
}

export function getDealList(apollo: ApolloState<{deals: DealList}, DealListVariables>): List {
  const deals: DealList = get(apollo, `data[${dealListQueryKey}]`, {})
  const {results = [], offset, limit, count, total, hasMore} = deals

  return {
    results,
    offset,
    limit,
    count,
    total,
    hasMore
  }
}

export interface DealListVariables extends Partial<QueryDealsArgs> {
  statuses: QueryDealsArgs["statuses"]
}

interface Props extends Omit<QueryComponentProps<{deals: DealList}, DealListVariables>, "query"> {}

export default class DealListComponent extends PureComponent<Props> {
  render() {
    const {children, ...props} = this.props
    return (
      <Query {...props} query={query}>
        {(apollo: ApolloState) => {
          const nextPage = (nextPageVariables: DealListVariables) => pagination({query, variables: nextPageVariables}, apollo)
          return this.props.children({...apollo, nextPage})
        }}
      </Query>
    )
  }
}
